
export function  fillLeadingZeros(num, size, prefix) {
  num = num.toString()
  while (num.length < size) num = "0" + num
  return prefix ?  prefix + num : num
}
